import React from "react";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {TwoColumnSliderSection} from "../components/TwoColumnSlider";
import StoryCollection from "../utils/StoryCollection";
import {TabbedStories} from "../components/common/TabbedStories";
import SectionDivider from "../components/common/SectionDivider";

const CulinaryPage: React.FC = () => {

    const roomSlides = [
        {
            image: '/images/room_1.webp'
        },
        {
            image: '/images/room_2.webp'
        },
        {
            image: '/images/room_3.webp'
        },
    ]

    const banquetStories: StoryCollection = {
        '1': ['/images/banquet_1.webp'],
        '2': ['/images/banquet_2.webp'],
        '3': ['/images/banquet_3.webp'],
    };

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                image="/images/banquet_3.webp"
                text="HOSPITALITY"
                nextSectionId="room-and-stay-section"
            />
            <TwoColumnSliderSection
                id="room-and-stay-section"
                title="ROOM & STAY" slides={roomSlides}
            />
            <SectionDivider/>
            <TabbedStories
                id="banquets-section"
                title="BANQUETS"
                stories={banquetStories}
                showTabs={false}
            />
        </div>
    );
};

export default CulinaryPage;